$.whitelabel = {
  dynamicField: {
    callback: {
      create: {
        success: function(data) {
          $('#modalDialog').modal('hide');
          $.whitelabel.dynamicField.pull.getAll();
        }
      },

      getAll: {
        success: function(data) {
          $.each(data.content, function(index, value) {
            $(document.createElement('tr'))
            .append(
              $(document.createElement('td'))
              .html(value.Title)
            )
            .append(
              $(document.createElement('td'))
              .html(value.Sort)
            )
            .append(
              $(document.createElement('td'))
              .html('-')
            )
            .appendTo('#dynamicFieldContentList');
          });
        }
      }
    },

    push: {
      create: function() {
        $('#dialogToolbar').ajax_callback('/json/admin/whitelabel/dynamicField/create', {
          'whitelabelId' : $('#whitelabelId').val(),
  				'dynamicFieldTitle' : $('#dynamicFieldTitle').val(),
  				'dynamicFieldSort' : $('#dynamicFieldSort').val(),
  			}, {
  				alertToolbar: false,
  				callback_success: $.whitelabel.dynamicField.callback.create.success
  			});
      }
    },

    pull: {
      getAll: function() {
        $('#dynamicFieldContentList').empty();

        $('#dialogToolbar').ajax_callback('/json/admin/whitelabel/dynamicField/getAll', {
          'whitelabelId' : $('#whitelabelId').val()
  			}, {
  				alertToolbar: false,
  				callback_success: $.whitelabel.dynamicField.callback.getAll.success
  			});
      }
    }
  },

  callback: {
    create: {
      success: function(data) {
        console.log('do success of create here!');
      }
    },

    update: {
      settings: {
        success: function(data) {
          location.reload();
        }
      }
    },

    getAll: {
      success: function(data) {
        $.each(data.content, function(index, value) {
          $(document.createElement('tr'))
          .append(
            $(document.createElement('td'))
            .html(value.Id)
          )
          .append(
            $(document.createElement('td'))
            .html(value.Title)
          )
          .append(
            $(document.createElement('td'))
            .html(value.Subdomain)
          )
          .append(
            $(document.createElement('td'))
            .addClass('text-right')
            .append(
              $(document.createElement('a'))
              .addClass('btn btn-success btn-xs')
              .attr({
                'href' : '/admin/whitelabel/view/'+ value.Id
              })
              .append(
                $(document.createElement('i'))
                .addClass('fa fa-pencil')
              )
            )
          )
          .appendTo('#contentList');
        });
      }
    }
  },

  push: {
    create: function() {
      $('#dialogToolbar').ajax_callback('/json/admin/whitelabel/create', {
				'whitelabelTitle' : $('#whitelabelTitle').val(),
				'whitelabelSubdomain' : $('#whitelabelSubdomain').val(),
				'whitelabelAccess' : $('#whitelabelAccess').val(),
			}, {
				alertToolbar: false,
				callback_success: $.whitelabel.callback.create.success
			});
    },

    update: function() {
      $('#dialogToolbar').ajax_callback('/json/admin/whitelabel/update/settings', {
				'whitelabelId' : $('#whitelabelId').val(),
				'whitelabelTitle' : $('#whitelabelTitle').val(),
				'whitelabelSubdomain' : $('#whitelabelSubdomain').val(),
				'whitelabelAccess' : $('#whitelabelAccess').val(),
			}, {
				alertToolbar: false,
				callback_success: $.whitelabel.callback.update.settings.success
			});
    }
  },

  pull: {
    getAll: function() {
      $('#dialogToolbar').ajax_callback('/json/admin/whitelabel/getAll', {
      }, {
        alertToolbar: false,
        callback_success: $.whitelabel.callback.getAll.success
      });
    }
  }
};

$(document).bind('pull-whitelabel-getAll:ready',function() {	$.whitelabel.pull.getAll(); });
$(document).bind('pull-whitelabel-dynamicField-getAll:ready',function() {	$.whitelabel.dynamicField.pull.getAll(); });
